import React, {useEffect} from 'react';
import DateRangePicker from 'react-bootstrap-daterangepicker';
import 'bootstrap-daterangepicker/daterangepicker.css';
import store from 'store';
import Select from 'react-select';
import {Trans, useTranslation} from 'react-i18next';
import timeUtils from '../../utils/timeUtils';

export const GlobalFilter = ({filter, setFilter, filterValue}) => {
  return (
    <div>
      Search:
      <input
        value={filter || ''}
        onChange={e => {
          setFilter(e.target.value);
        }}
      />
    </div>
  );
};

// filter component
export const TextFilter = ({column: {filterValue, setFilter, storeFilter}}) => {
  useEffect(() => {
    setFilter(store.get(storeFilter));
  }, []);

  return (
    <input
      value={
        store.get(storeFilter) ? store.get(storeFilter) : filterValue || ''
      }
      onChange={e => {
        if (storeFilter) {
          store.set(storeFilter, e.target.value);
        }
        setFilter(e.target.value || undefined);
      }}
      className="form-control input-sm"
    />
  );
};

// filter component
export const DateRangeFilter = ({column: {filterValue, setFilter, query}}) => {
  const {t} = useTranslation();
  return (
    <DateRangePicker
      onApply={(event, picker) => {
        const {startDate, endDate} = picker;
        const display = `${startDate.format(
          timeUtils.shortTimeFormat()
        )} - ${endDate.format(timeUtils.shortTimeFormat())}`;
        setFilter([startDate.toISOString(), endDate.toISOString(), display]);
      }}
      autoUpdateInput={false}
      drops="down"
      opens="center"
      locale={{
        customRangeLabel: t('c.r.daterange.custom.range', 'Custom Range'),
        applyLabel: t('c.r.daterange.apply', 'Apply'),
        cancelLabel: t('c.r.daterange.cancel', 'Cancel'),
        format: timeUtils.shortTimeFormat(),
        monthNames: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12],
        daysOfWeek: [
          t('c.r.daterange.sunday', 'Su'),
          t('c.r.daterange.monday', 'Mo'),
          t('c.r.daterange.tuesday', 'Tu'),
          t('c.r.daterange.wednesday', 'We'),
          t('c.r.daterange.thursday', 'Th'),
          t('c.r.daterange.friday', 'Fr'),
          t('c.r.daterange.saturday', 'Sa'),
        ],
      }}
    >
      <div
        className="input-group"
        style={{color: 'transparent', flexWrap: 'nowrap'}}
      >
        <div className="input-group-prepend">
          <span className="input-group-text">
            <i className="fa fa-calendar" />
          </span>
        </div>
        <input
          type="text"
          className="form-control"
          value={
            filterValue ? (query ? filterValue.display : filterValue[2]) : ''
          }
          readOnly={true}
          style={{backgroundColor: '#fff'}}
        />
      </div>
    </DateRangePicker>
  );
};

// filter component
export const DropdownFilter = ({
  column: {filterValue, setFilter, options, preFilteredRows, id, storeFilter},
}) => {
  let opts = options
    ? new Set(options)
    : retrieveOptionsFromRows(preFilteredRows, id);
  return (
    <div>
      <Select
        onChange={o => {
          setFilter(o && o.value);
        }}
        options={options}
        value={options.find(o => o.value === filterValue) || null}
        isSearchable={false}
        isClearable={true}
        placeholder={<Trans i18nKey="c.c.select.placeholder">Select...</Trans>}
        styles={{
          menu: baseStyles => ({
            ...baseStyles,
            width: 'auto',
          }),
        }}
      />
    </div>
  );
};

function retrieveOptionsFromRows(rows, id) {
  let optLabel = new Set();
  let optValue = new Set();
  rows.forEach((row, i) => {
    const columnValue = row.values && row.values[id];
    if (
      typeof columnValue === 'object' &&
      columnValue &&
      columnValue.value &&
      (columnValue.label || columnValue.text)
    ) {
      optLabel.add(columnValue.label);
      optValue.add(columnValue.value);
      return;
    }
    if (Array.isArray(columnValue)) {
      columnValue.forEach((opt, i) => optValue.add(opt));
      return;
    }
    if (columnValue !== '') {
      optValue.add(columnValue);
    }
  });
  const valueArr = Array.from(optValue);
  const labelArr = Array.from(optLabel);
  return valueArr.map((opt, i) => ({
    value: opt,
    label: labelArr[i] ? labelArr[i] : opt,
  }));
}
